import React from 'react';
import styles from './studio_lorranycastro.module.scss';
import ImageLink1 from './src/1.png';
import ImageLink2 from './src/2.png';
import ImageLink3 from './src/3.png';
import ImageLink4 from './src/4.png';
import ImageLink5 from './src/5.png';
import LogoBranca from './src/logo_branca.png';
import { Link } from 'react-router-dom';

const Studio_lorranycastro: React.FC = () => {
    return (
        <div className={styles.studio_lorranycastro}>
            <div className={styles.container}>
                <div className={styles.principalContent}>
                    <div className={styles.content}>
                        <img
                            className={styles.logo}
                            src={LogoBranca}
                            alt="Lorrany Castro Studio"
                        />
                        <h1 className="mb-2">Olá, Maravilhosa!</h1>
                        <p className={`${styles.textGray} mb-2`}><b>Essa página tem todos os links que você precisa para prosseguir.</b></p>
                        <p><b>Clique no destino desejado!</b></p>
                        <div className={styles.linksContainer}>
                            <a
                                href="https://novu035.gendo.app"
                                className={styles.link}>
                                <img src={ImageLink1} alt="Link 1" />
                            </a>
                            <Link to="/studio_lorranycastro/curso" className={styles.link}>
                                <img src={ImageLink2} alt="Link 2" />
                            </Link>
                            <a
                                href="https://wa.me/5517991791926?text=Olá, tudo bem? Vim pelo Instagram e gostaria de informações sobre a extensão de cílios?"
                                className={styles.link}>
                                <img src={ImageLink3} alt="Link 3" />
                            </a>
                            <a
                                href="https://wa.me/message/ZTXAMGLOLXZO"
                                className={styles.link}>
                                <img src={ImageLink4} alt="Link 4" />
                            </a>
                            <a
                                href="https://maps.app.goo.gl/LoP6ujeFfq5rNuK98I1"
                                className={`${styles.link} mb-4`}>
                                <img src={ImageLink5} alt="Link 5" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Studio_lorranycastro;
